package com.vizio.redwolf.utils

data class OffersEnvironmentConfig(val environmentGroup: EnvironmentGroup)